import Metrics from 'ember-metrics/services/metrics';

export default class extends Metrics {
  constructor() {
    super(...arguments);
  }
}
